import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/maintenance_dob/applicationSchedulesReportActions'
import * as api from '../../../api/reports/maintenance_dob/applicationSchedulesReport'

function* applicationSchedulesReportGetJobList(action) {
  try {
    const payload = yield call(api.getJobList, action.filters)
    yield put({ type: constants.APPLICATION_SCHEDULES_REPORT_GET_JOB_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.APPLICATION_SCHEDULES_REPORT_GET_JOB_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* applicationSchedulesReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.APPLICATION_SCHEDULES_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.APPLICATION_SCHEDULES_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */

function* watchapplicationSchedulesReportGetJobList() {
  yield takeLatest(
    constants.APPLICATION_SCHEDULES_REPORT_GET_JOB_LIST.ACTION,
    applicationSchedulesReportGetJobList
  )
}

function* watchapplicationSchedulesReportGetFullReport() {
  yield takeLatest(
    constants.APPLICATION_SCHEDULES_REPORT_GET_FULL_REPORT.ACTION,
    applicationSchedulesReportGetFullReport
  )
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchapplicationSchedulesReportGetJobList),
    fork(watchapplicationSchedulesReportGetFullReport)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/maintenance_dob/applicationSchedulesReportSaga.js